import React, { useContext, useEffect, useState } from "react";
import { GetActiveTasksForTelerikGrid } from "../../../../../services/api/task-telerik-api";
import { TaskGrid } from "./task-grid";
import { ModifyTaskData } from "./task-util";
import { TaskMainHeader } from "../common-components/task-main-header";
import "../common-components/tasks.scss";
import { Helmet } from "react-helmet-async";
import { LoginContext } from "../../../../../services/api/authentication-api";
import { TaskListSkeleton } from "../common-components/tasklist-skeleton";

export const TaskMain = () => {
  const [data, setData] = useState({
    data: null,
    isLoading: true,
  });
  const [type, setType] = useState("Active");
  const user = useContext(LoginContext);
  const labels = user?.currentUser?.objectLabels;
  const canCreate =
  (user?.currentUser?.privileges?.["Task Management"]?.Add ?? false) ||
  (user?.currentUser?.privileges?.["Document Collaboration"]?.Add ?? false);

  const GetTasks = async () => {
    try {
      setData((prev) => ({
        ...prev,
        isLoading: true,
      }));

      let result = await GetActiveTasksForTelerikGrid(type);
      let modifiedResult = ModifyTaskData(
        result?.data.data,
        user?.currentUser?.department?.DateFormatID
      );

      setData((prev) => ({
        ...prev,
        data: modifiedResult,
        allColumns: result?.data.allColumns,
        isLoading: false,
      }));
    } catch (e) {
      console.log("Error [GetActiveTasksForTelerikGrid] => ", e);
    }
  };

  useEffect(() => {
    GetTasks();
  }, [type]);

  return (
    <div className="task-main">
      <Helmet>
        <title> TRIYO · {labels?.TaskPlural ?? 'Tasks'} </title>
      </Helmet>
      <TaskMainHeader data={data} type={type} setType={setType} canCreate={canCreate} labels={labels} />
      {data.isLoading ? (
        <TaskListSkeleton />
      ) : (
        <div className="task-tab-grid dashboard-container-shadow">
          <TaskGrid data={data} GetTasks={GetTasks} type={type} />
        </div>
      )}
    </div>
  );
};
